import { fetchAPI } from "./baseApi";

export async function getResearchAdmin() {
  return fetchAPI("/research/admin", { method: "GET" });
}

export async function createResearch(data) {
  return fetchAPI("/research/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateResearch(id, data) {
  return fetchAPI(`/research/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteResearch(id) {
  return fetchAPI(`/research/admin/${id}`, { method: "DELETE" });
}
